module.exports = __webpack_public_path__ + "img/LA.75d2a027.svg";